import { getProfileName } from "PFCore/helpers/profile";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { MatchedActivity } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import { Section } from "../../components";
import { StatColumn } from "./stat_column";
import css from "./stats_section.module.scss";

type StatsSectionProps = {
  role: MatchedActivity["activity"];
};

export const StatsSection = ({ role }: StatsSectionProps) => {
  const { t } = useTranslation("marketplace", { keyPrefix: "workOpportunities.roleDetails.stats" });
  const { formatDate } = useDateFormatter();
  const interestedCount = role.statistics.interests_count;
  const sharedCount = role.statistics.shares_count;

  return (
    <Section>
      <div className={css.mainContainer}>
        <StatColumn title={t("labels.created")} content={formatDate(role.created_at)} />
        <StatColumn title={t("labels.createdBy")} content={getProfileName(role.profile)} />
        {interestedCount > 0 && (
          <StatColumn
            title={t("labels.interested")}
            content={t("values.interested", { count: interestedCount })}
          />
        )}
        {sharedCount > 0 && (
          <StatColumn title={t("labels.shared")} content={t("values.shared", { count: sharedCount })} />
        )}
      </div>
    </Section>
  );
};
